/**
 * The function whose prototype all chaining wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



// WEBPACK FOOTER //
// ./~/lodash/internal/baseLodash.js